import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ProfileImageUpload = ({ currentImage, onImageChange, className = '' }) => {
  const [previewImage, setPreviewImage] = useState(currentImage);
  const [isUploading, setIsUploading] = useState(false);

  const handleImageSelect = (event) => {
    const file = event?.target?.files?.[0];
    if (!file) return;

    // Validate file type
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
    if (!allowedTypes?.includes(file?.type)) {
      alert('فرمت فایل باید JPG، PNG یا WebP باشد');
      return;
    }

    // Validate file size (max 5MB)
    if (file?.size > 5 * 1024 * 1024) {
      alert('حجم فایل نباید بیشتر از ۵ مگابایت باشد');
      return;
    }

    setIsUploading(true);

    // Create preview
    const reader = new FileReader();
    reader.onload = (e) => {
      setPreviewImage(e?.target?.result);
      onImageChange?.(file, e?.target?.result);
      setIsUploading(false);
    };
    reader?.readAsDataURL(file);
  };

  const handleRemoveImage = () => {
    setPreviewImage(null);
    onImageChange?.(null, null);
  };

  return (
    <div className={`space-y-4 ${className}`}>
      <div className="flex flex-col items-center">
        <div className="relative">
          <div className="w-32 h-32 rounded-full overflow-hidden bg-muted border-4 border-border">
            {previewImage ? (
              <Image
                src={previewImage}
                alt="تصویر پروفایل"
                className="w-full h-full object-cover"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center">
                <Icon name="User" size={48} className="text-muted-foreground" />
              </div>
            )}
          </div>

          {/* Upload button overlay */}
          <div className="absolute bottom-0 right-0">
            <label htmlFor="profile-image-upload">
              <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center cursor-pointer hover:bg-primary/90 transition-colors duration-150 border-2 border-card">
                <Icon name="Camera" size={20} color="white" />
              </div>
              <input
                id="profile-image-upload"
                type="file"
                accept="image/jpeg,image/jpg,image/png,image/webp"
                onChange={handleImageSelect}
                className="hidden"
              />
            </label>
          </div>
        </div>

        {isUploading && (
          <div className="mt-2 text-sm text-muted-foreground">
            در حال آپلود...
          </div>
        )}
      </div>

      <div className="text-center space-y-2">
        <p className="text-sm text-muted-foreground">
          فرمت‌های مجاز: JPG، PNG، WebP
        </p>
        <p className="text-xs text-muted-foreground">
          حداکثر حجم: ۵ مگابایت
        </p>

        {previewImage && (
          <Button
            variant="outline"
            size="sm"
            onClick={handleRemoveImage}
            iconName="Trash2"
            iconPosition="right"
            className="mt-2"
          >
            حذف تصویر
          </Button>
        )}
      </div>
    </div>
  );
};

export default ProfileImageUpload;